export default RAILS_ASSET_URL("/gallery-image-06.webp")
